export var SizeEnum;
(function (SizeEnum) {
    SizeEnum["tiny"] = "tiny";
    SizeEnum["small"] = "small";
    SizeEnum["medium"] = "medium";
    SizeEnum["large"] = "large";
    SizeEnum["giant"] = "giant";
})(SizeEnum || (SizeEnum = {}));
export var EmphasisEnum;
(function (EmphasisEnum) {
    EmphasisEnum["primary"] = "primary";
    EmphasisEnum["secondary"] = "secondary";
    EmphasisEnum["tertiary"] = "tertiary";
    EmphasisEnum["danger"] = "danger";
    EmphasisEnum["warning"] = "warning";
    EmphasisEnum["success"] = "success";
    EmphasisEnum["grey"] = "grey";
})(EmphasisEnum || (EmphasisEnum = {}));
export var EmphasisInverseEnum;
(function (EmphasisInverseEnum) {
    EmphasisInverseEnum["primary"] = "primaryInverse";
    EmphasisInverseEnum["secondary"] = "secondaryInverse";
    EmphasisInverseEnum["tertiary"] = "tertiaryInverse";
    EmphasisInverseEnum["danger"] = "dangerInverse";
    EmphasisInverseEnum["warning"] = "warningInverse";
    EmphasisInverseEnum["success"] = "successInverse";
    EmphasisInverseEnum["grey"] = "greyInverse";
})(EmphasisInverseEnum || (EmphasisInverseEnum = {}));
export var TagColorEnum;
(function (TagColorEnum) {
    TagColorEnum["red"] = "#ff3939";
    TagColorEnum["purple"] = "#cf32e6";
    TagColorEnum["blue"] = "#406dff";
    TagColorEnum["teal"] = "#50dede";
    TagColorEnum["green"] = "#4bd24b";
    TagColorEnum["orange"] = "#ff9f44";
    TagColorEnum["grey"] = "#777777";
})(TagColorEnum || (TagColorEnum = {}));
export var ButtonVariantEnum;
(function (ButtonVariantEnum) {
    ButtonVariantEnum["button"] = "button";
    ButtonVariantEnum["outline"] = "outline";
    ButtonVariantEnum["text"] = "text";
})(ButtonVariantEnum || (ButtonVariantEnum = {}));
export var ThemeConstantEnum;
(function (ThemeConstantEnum) {
    ThemeConstantEnum["transparent"] = "transparent";
})(ThemeConstantEnum || (ThemeConstantEnum = {}));
